var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "announcement section" }, [
      _c("p", [_vm._v(_vm._s(_vm.$t("unsubscriptionAnnounce.title")))]),
      _c("div", { staticClass: "description" }, [
        _c("div", { staticClass: "margin-bottom" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("unsubscriptionAnnounce.description.thankYou")) +
              " "
          ),
        ]),
        _c("div", [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("unsubscriptionAnnounce.description.confirmation")
              ) +
              " "
          ),
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t("unsubscriptionAnnounce.description.confirmationBold")
              )
            ),
          ]),
          _vm._v(
            _vm._s(
              _vm.$t("unsubscriptionAnnounce.description.confirmationSuffix")
            ) + " "
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "precautions section" }, [
      _c("table", { staticClass: "primary" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { staticClass: "title" }, [
              _vm._v(
                _vm._s(_vm.$t("unsubscriptionAnnounce.precautions.title"))
              ),
            ]),
          ]),
        ]),
        _c("tbody", [
          _c("tr", [
            _c("td", [
              _c("table", { staticClass: "secondary" }, [
                _c("tbody", [
                  _c("tr", [
                    _vm._m(0),
                    _c("td", [
                      _c("div", { staticClass: "sub-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "unsubscriptionAnnounce.precautions.item1.subtitle"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "message" }, [
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "unsubscriptionAnnounce.precautions.item1.message1"
                        )
                      ) +
                      " "
                  ),
                ]),
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "unsubscriptionAnnounce.precautions.item1.message2"
                        )
                      ) +
                      " "
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._m(1),
          _c("tr", [
            _c("td", [
              _c("table", { staticClass: "secondary" }, [
                _c("tbody", [
                  _c("tr", [
                    _vm._m(2),
                    _c("td", [
                      _c("div", { staticClass: "sub-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "unsubscriptionAnnounce.precautions.item2.subtitle"
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "message" }, [
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "unsubscriptionAnnounce.precautions.item2.message1"
                        )
                      ) +
                      " "
                  ),
                ]),
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "unsubscriptionAnnounce.precautions.item2.message2"
                      )
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "operation section" },
      [
        _c(
          "span",
          { staticClass: "disclaimer" },
          [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("unsubscriptionAnnounce.operation.disclaimerPrefix")
                )
              ),
            ]),
            _c(
              "router-link",
              {
                staticClass: "membership",
                attrs: { to: { name: "membership" }, target: "_blank" },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("unsubscriptionAnnounce.operation.membershipTerms")
                  )
                ),
              ]
            ),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t("unsubscriptionAnnounce.operation.disclaimerSuffix")
                )
              ),
            ]),
          ],
          1
        ),
        _c(
          "button",
          {
            staticClass: "button-design submit margin-bottom",
            attrs: { type: "submit" },
            on: { click: _vm.onSubmit },
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("unsubscriptionAnnounce.operation.submitButton")
                ) +
                " "
            ),
          ]
        ),
        _c(
          "router-link",
          {
            staticClass: "button-design cancel",
            attrs: { to: { name: "paymentManagement" } },
          },
          [_vm._v(_vm._s(_vm.$t("common.cancel")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [_c("div", { staticClass: "number" }, [_vm._v("1")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("tr", { staticClass: "horizontal-rule" }, [_c("td", [_c("hr")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [_c("div", { staticClass: "number" }, [_vm._v("2")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }